function irsCompressor(investment_returns, new_id){
  const stock_fields = ['value','pending','intacc']
  const sum_fields   = ['ret','buy','sell','income','pending_change']
  const dates = [...new Set(investment_returns.map(ir => ir.date))].sort()
  const ids = [...new Set(investment_returns.map(ir => ir.investment_id))].sort()
  const grouped = {}

  if(ids.length <= 1){
    return investment_returns
  }

  // ITERATORS
  var nextDate
  var start_index
  var end_index
  var subset
  var i
  var record
  var clean_value = 0

  ids.forEach((id) => {
    grouped[id] = investment_returns.filter(ir => ir.investment_id === id)
  })
  const output = dates.map((dt) => {
    return {
      investment_id: new_id,
      date: dt,
      intacc: 0,
      pending: 0,
      pending_change: 0,
      value: 0,
      ret: 0,
      buy: 0,
      sell: 0,
      income: 0,
    }
  })

  stock_fields.forEach((field) => {
    ids.forEach((id)=>{
      // GET SIMPLE vALUE dATA ON INVESTMENT
      subset = grouped[id].map(ir => [ir.date, ir[field]])
      // SORT FROM LAST DATE TO FIRST DATE
      subset.sort((a,b) => a[0]>b[0] ? 1 : -1)
      // FOR EACH VALUE IN SUBSET find start and end and add value to theese
      // if(inv.asset_class==="Total" && field ==='value'){window.console.log(subset)}
      subset.forEach((item, index)=>{
        start_index = output.findIndex(ir => ir.date === item[0])
        if((index+1) === subset.length){
          if(item[1]===0){
            end_index = start_index + 1
          } else {
            end_index = output.length
          }
        } else {
          nextDate = subset[index+1][0]
          end_index = output.findIndex(ir => ir.date === nextDate)
        }
        for (i = start_index; i < end_index; i++) {
          output[i][field] += item[1]
        }
      })
    })
  })
  // if(inv.asset_class==="Total"){window.console.log(output)}

  // SUM UP sum_fields
  investment_returns.forEach((ir) => {
    record = output.find(row => row.date === ir.date)
    sum_fields.forEach((field) => {
      record[field] += ir[field]
    })
  })

  output.forEach((ir, index) => {
    ir.holding = ir.value >= 0 ? 1 : -1
    ir.clean_value_1 = clean_value
    clean_value = ir.value - ir.pending - ir.intacc
    ir.clean_value = clean_value
    ir.pending_1 = (output[index-1]||{pending: 0}).pending
  })

  output.filter(ir => ir.holding === 1).forEach((ir) => {
    ir.base = ir.clean_value_1 + Math.max(ir.buy-ir.sell,0)
  })
  output.filter(ir => ir.holding === -1).forEach((ir) => {
    ir.base = Math.abs(ir.clean_value_1) + Math.max(ir.sell-ir.buy,0)
  })

  output.forEach((ir)=>{
    ir.base += Math.abs(ir.pending_1)
    ir.rpct = ir.ret / ir.base
    delete ir['clean_value_1']
    delete ir['pending_1']
  })

  return output
}

export default irsCompressor
